import { Injectable } from '@angular/core';
import { CourseLevel, SyllabusHttpModel } from '@examdojo/category/v2';
import { ExamdojoSupabaseService, SupabaseBaseHttpService } from '@examdojo/supabase';
import { from } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AssessmentHttpService extends SupabaseBaseHttpService<'assessments', 'learning'> {
  constructor(protected override readonly supabase: ExamdojoSupabaseService) {
    super(supabase);
  }

  readonly schema = 'learning';
  readonly tableName = 'assessments';

  override fetchAll(filters?: { syllabusId?: SyllabusHttpModel['id']; courseLevel?: CourseLevel | null }) {
    let query = this.supabase.client.schema(this.schema).from(this.tableName).select();

    if (filters?.syllabusId) {
      query = query.eq('syllabus_id', filters.syllabusId);
    }
    if (filters?.courseLevel) {
      query = query.eq('course_level', filters.courseLevel);
    }

    return from(query.throwOnError().then((response) => response.data!));
  }

  setActive(id: number) {
    return from(
      this.supabase.client
        .schema('learning')
        .rpc('set_assessment_active', { assessement_id: id })
        .throwOnError()
        .then((res) => (res.data ?? [])[0]),
    );
  }
}
